import React from 'react'
import '../css/Testpage.css'

import TDCSpecialtyLogo from "../assets/TDCSIC-TDCG_White.png"
import HomeNavbar from '../components/HomeNavbar'
import { useEffect } from 'react'
import { AppConfigurationClient } from '@azure/app-configuration'
import { useState } from 'react'
import { ArrowSmallRightIcon } from '@heroicons/react/24/outline'
import { BiArrowToRight } from 'react-icons/bi'
import { loginRequest } from '../authConfig'
import { useMsal } from '@azure/msal-react'
import { Link } from 'react-router-dom'
function TDCLandingPage() {
  const [appConfigVars, setAppConfigVars] = useState(null)
  const [accessToken, setAccessToken] = useState(null)
  const [account, setAccount] = useState(null)


  const {REACT_APP_CONFIG_KEYS, REACT_APP_HRA_CONFIG_ENDPOINT} = process.env
  
  const client = new AppConfigurationClient(
      `Endpoint=${REACT_APP_HRA_CONFIG_ENDPOINT}`
    );
    
    const {instance} = useMsal()
    async function getKeyValues() {
      let tempMap = {}
      const keys = REACT_APP_CONFIG_KEYS.split(',').filter(item => !item.includes('BROKER_APP'));
      for(var i = 0; i<keys.length;i++){
         
          let retrievedSetting = await client.getConfigurationSetting({
              key:keys[i]
            });
         
            tempMap[keys[i].split('REACT_APP_')[1]] = retrievedSetting.value
            
            console.log(tempMap)
      }
    
     
      setAppConfigVars(tempMap)
  
    }
    useEffect(() => {
     getKeyValues()
    }, [])
    useEffect(() => {
      console.log(appConfigVars?.EMBED_KEY)
    }, [appConfigVars])

   
         useEffect(() => {
         if(window.sessionStorage.hasOwnProperty('account')){
            setAccount(JSON.parse(window.sessionStorage.getItem('account')))
         }
         }, [])
         



    const handleLogin = () => {
        /* instance.loginPopup(loginRequest).catch(e => {
             console.log(e);
         }); */
         if(account!==null) return
         instance.loginRedirect(loginRequest).then(response=>{
          
          return instance
         }).catch(e => {
           console.log(e);
       });
     }
  return (

<div className='w-screen p-10 flex flex-col justify-start h-screen relative bg-black'>
    <div className='w-full h-fit'>
        <img className='w--auto h-20' src={TDCSpecialtyLogo} alt="" />
    </div>
    <div className='px-20'>
    <div className='text-white my-20 w-fit'>
        <h1 className='text-5xl'>DATA ANALYTICS</h1>
        <h5 className=' text-shadow-lg text-2xl font-light'>BUSINESS INTELLIGENCE DASHBOARDS IN REAL-TIME</h5>
        <Link to="/dashboard" onClick={handleLogin} className='bg-white w-full py-2 my-5  flex flex-row justify-center items-center text-black text-shadow-xl  text-xl'>{account===null?"Sign In":"Dashboard" }<BiArrowToRight className='w-8 h-8'/></Link>
        
    </div>
    <div>
    

    </div>
    </div>
   
  

   
    
</div>
   
        
   
  )
}

export default TDCLandingPage
